import { useSelector } from 'react-redux';
import { toast } from 'sonner';
import ConfirmDeleteButton from '@/components/common/ConfirmDeleteButton';
import { useDeleteCommentMutation } from './comment.api.slice';
import { selectCurrentUser } from '../auth/auth.slice';

function DeletePostComment({
  postId,
  userId,
  commentId,
}: {
  postId: string;
  userId: string;
  commentId: string;
}) {
  const { isAuthenticated, user } = useSelector(selectCurrentUser);
  const [deletePostComment, { isLoading }] = useDeleteCommentMutation();

  const handlePostCommentDelete = async () => {
    try {
      await deletePostComment({ postId, commentId }).unwrap();
      toast.success('Comment deleted');
    } catch (error) {
      toast.error('Failed to delete the comment. Please try again.');
    }
  };

  if (!isAuthenticated) {
    return <div />;
  }

  if (
    userId !== user?._id &&
    !user?.email.endsWith('@onefinitycnc.com') &&
    user?.isVerified
  ) {
    return <div />;
  }

  return (
    <ConfirmDeleteButton
      onConfirm={handlePostCommentDelete}
      disabled={isLoading}
      label="Delete comment"
      description="Are you sure you want to delete this comment? This action cannot be undone."
    />
  );
}

export default DeletePostComment;
